import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
import Rellax from "rellax";
import AOS from "aos";
require("./helpers/pageTimeline");
// Transition Ecosystem
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
require("./helpers/Timeline");
require('plyr');
// Ui item
import GLightbox from "glightbox";
import { carouselWrapper } from "./helpers/CarouselWrapper";
// GDPR Custom System
// require ('./helpers/CookieConsent');
// Controllers
require("./helpers/newsletterController");
let mapGlobal;
// Define all actions
let Site = {
    // Plugins
    carousel: carouselWrapper,
    // Actions
    init: () => {
        Site.global();
    },
    transition: (response) => {
        Site.global();
        Site.scripts(response);
    },
    global: () => {
        Site.carousel();
        GLightbox({
            touchNavigation: false,
            touchFollowAxis: false,
            keyboardNavigation: false,
        });
        Site.filters();
        Site.map();
        if ($(window).width() < 600) {
            $("[data-aos='fade-left']").attr("data-aos", "fade-up");
        }
        AOS.init({
            disable: 'mobile'
        });
        setTimeout(() => { AOS.refresh(); }, 500);
    },
    map: () => {
    },
    filters: () => {
    },
    scripts: (response) => {
        var initialized_scripts = [];
        var script_tags = document.getElementsByTagName("script");
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                initialized_scripts.push(src);
            }
        });
        var new_imports = [];
        var new_evaluations = '';
        var script_tags = $(response).find('script');
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                // if not already initialized add it
                if (initialized_scripts.indexOf(src) == -1) {
                    new_imports.push(src);
                }
            }
            else {
                // it is an inline script, will evaluate it
                new_evaluations += script_tags[i].innerHTML;
            }
        });
        $.getMultiScripts(new_imports).done(function () {
            eval(new_evaluations);
        }).fail(function (error) {
            // one or more scripts failed to load
        }).always(function () {
            // always called, both on success and error
        });
    }
};
$(document).ready(function () {
    Site.init();
    $(".filter-parent .chosen").on("click", (e) => {
        let c = $(e.currentTarget);
        if ($('.filters').hasClass("opened") && !c.parent(".filter-parent").hasClass("is-open")) {
            let alreadyOpened = $(".filter-parent.is-open");
            alreadyOpened.toggleClass("is-open");
            alreadyOpened.next('.filters-wrapper').slideToggle(250);
        }
        c.parent(".filter-parent").toggleClass("is-open");
        c.parent(".filter-parent").next('.filters-wrapper').slideToggle(250, () => {
            if ($(".filter-parent").hasClass("is-open")) {
                $('.filters').addClass("opened");
            }
            else {
                $('.filters').removeClass("opened");
            }
        });
    });
    let pLength = $('.filter-parent').length;
    let clearAll = false;
    $(".clear-all").on("click", "a", (e) => {
        e.preventDefault();
        clearAll = true;
        $('.all.filter').find("label").trigger("click");
        if ($('.filters').hasClass("opened")) {
            let alreadyOpened = $(".filter-parent.is-open");
            alreadyOpened.toggleClass("is-open");
            alreadyOpened.next('.filters-wrapper').slideToggle(250);
            $('.filters').removeClass("opened");
        }
    });
    $('.filter label').on("click", (e) => {
        let parents = $(e.currentTarget).parents(".filters-wrapper");
        $('.is-hidden').show();
        $('.Button[href="#show-more"]').hide();
        let parent = $(e.currentTarget).parent();
        let value = parent.children("input").val();
        parents.prev('.filter-parent').find(".value").html($(e.currentTarget).html());
        parents.prev('.filter-parent').attr("data-value", value);
        let values = "";
        $(".filter-parent").each((k, v) => {
            if ($(v).attr("data-value") != "all")
                values += "." + $(v).attr("data-value");
            if (k == pLength - 1) {
                if (clearAll || values == "") {
                    $(".hidden").fadeIn(250, () => {
                        $('.hidden').removeClass("hidden");
                    });
                    $('.parent').fadeIn(250);
                    $(".clear-all").fadeOut(300);
                    $(".sorry").hide();
                    clearAll = false;
                }
                else {
                    $(".clear-all").fadeIn(300);
                    let elements = $('.parent-article-item' + values);
                    $('.parent-article-item').hide().addClass("hidden");
                    elements.fadeIn(250, () => { }).removeClass("hidden");
                    setTimeout(() => {
                        let length = $('.parent').length;
                        let showSorry = true;
                        $('.parent').each((k, v) => {
                            let l = $(v).find(".parent-article-item:not(.hidden)");
                            if (l.length == 0) {
                                $(v).fadeOut(250);
                            }
                            else {
                                $(v).fadeIn(250);
                                showSorry = false;
                            }
                            if (k == length - 1) {
                                if (showSorry)
                                    setTimeout(() => { $(".sorry").fadeIn(250); }, 250);
                                else if (!showSorry)
                                    $(".sorry").hide();
                            }
                        });
                    }, 250);
                }
            }
        });
    });
    if ($('.accordion').length) {
        $('.accordion').on("click", ".header > a", (e) => {
            e.preventDefault();
            $(e.currentTarget).toggleClass("less");
            $(e.currentTarget).parent().next().slideToggle(250);
        });
    }
    if ($('.is-hidden').length) {
        $('body').on("click", "a[href='#show-more']", (e) => {
            e.preventDefault();
            $(e.currentTarget).parent().prev().find('.is-hidden').fadeIn(250);
            $(e.currentTarget).parent().fadeOut(250);
        });
    }
    $("body").on("click", "a[data-goto]", (e) => {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            // const posY = $(node).offset().top - $("#main-header").height();
            const posY = $(node).offset().top;
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", (e) => {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    let isNegative = $("#main-header").hasClass("negative");
    $("body").on("click", "#menu-switcher a.switcher", (e) => {
        e.preventDefault();
        $("#main-header").removeClass("negative");
        if (isNegative && $("#nav-main").hasClass("show-menu")) {
            $("#main-header").addClass("negative");
        }
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo, [href^='#']", (e) => {
        if (!$(e.currentTarget).hasClass("no-goto")) {
            const elm = $(e.currentTarget).attr("href");
            if ($(elm).length) {
                const posY = $(elm).offset().top;
                $.scrollTo(posY, 400);
            }
        }
    });
    var lastScrollTop = 0;
    let scrollFn = function () {
        var st = $(window).scrollTop();
        if (st > 250) {
            if (st > lastScrollTop) {
                $('#main-header').addClass('scrolled');
            }
            else {
                $('#main-header').removeClass('scrolled');
            }
        }
        else {
            $('#main-header').removeClass('scrolled');
        }
        lastScrollTop = st;
    };
    $(window).scroll(scrollFn);
    scrollFn.call(null);
    if ($('.rellax').length) {
        var rellax = new Rellax('.rellax');
    }
    if ($("#player").length) {
        const player = new Plyr('#player');
    }
});
